<template>
  <div class="activityDialog">
    <el-dialog
      title="请选择活动"
      :visible.sync="visible"
      width="600px"
      :before-close="close">
      <div class="content">
        <div class="tips">本单已满足以下活动，请至少选择一项</div>
        <div class="list">
          <div class="list_section">
            <div class="list_section_title">
              <div class="list_section_title_name">满额换购</div>
              <div class="list_section_title_description">（任选1项）</div>
            </div>
            <el-radio-group class="list_radio_group" v-model="orderMultipleMap.number" @input="orderMultipleChange">
              <el-radio v-for="(activity, activityIndex) in orderMultipleMap.list" :key="activity.id" class="list_radio" :label="activity.number">
                <div class="activity_item">
                  <div class="activity_title">
                    <div class="activity_title_name">活动{{ activityIndex + 1 }}：</div>
                    <div class="activity_title_description">满{{ activity.threshold }}可<span class="activity_title_price">{{ activity.presentPriceCount }}元换购价值{{ activity.originalPriceCount }}元</span>的商品，共{{ activity.medCount }}件</div>
                  </div>
                  <div class="activity_gifts">{{ activity.giftsText }}</div>
                </div>
              </el-radio>
              <el-radio class="list_radio" label="">
                <div class="activity_item">
                  <div class="activity_title">
                    <div class="activity_title_name">不参加活动</div>
                  </div>
                </div>
              </el-radio>
            </el-radio-group>
          </div>

          <div class="list_section">
            <div class="list_section_title">
              <div class="list_section_title_name">下单送券</div>
              <div class="list_section_title_description">（任选1项）</div>
            </div>
            <el-radio-group class="list_radio_group" v-model="orderGiftMap.number">
              <el-radio v-for="(activity, activityIndex) in orderGiftMap.list" :key="activity.id" class="list_radio" :label="activity.number">
                <div class="activity_item">
                  <div class="activity_title">
                    <div class="activity_title_name">活动{{ activityIndex + 1 }}：</div>
                    <div class="activity_title_description">满{{ activity.threshold }}赠送总值<span class="activity_title_price">{{ activity.couponsPriceCount }}元</span>的券包，共{{ activity.couponsCount }}张</div>
                    <div v-if="activity.supportDiscount === 2" class="activity_title_tag">不可议价</div>
                  </div>
                  <div class="coupon_list">
                    <div v-for="coupon in activity.coupons" :key="coupon.couponId" class="coupon_item">
                      <div class="coupon_item_title">{{ coupon.couponName }}</div>
                      <div class="coupon_item_num">
                        <div class="coupon_item_num_element">
                          <div class="coupon_item_num_element_num">{{ coupon.couponMoney }}</div><div class="coupon_item_num_element_unit">元</div>
                        </div>
                        <div class="coupon_item_num_element">
                          <div class="coupon_item_num_element_unit">×</div>
                        </div>
                        <div class="coupon_item_num_element">
                          <div class="coupon_item_num_element_num">{{ coupon.count }}</div><div class="coupon_item_num_element_unit">张</div>
                        </div>
                      </div>
                      <div class="coupon_item_condition">{{ coupon.couponMoneyFloor > 0 ? `满${coupon.couponMoneyFloor}可用` : '无门槛券' }}</div>
                    </div>
                  </div>
                </div>
              </el-radio>
              <el-radio class="list_radio" label="">
                <div class="activity_item">
                  <div class="activity_title">
                    <div class="activity_title_name">不参加活动</div>
                  </div>
                </div>
              </el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { getActivityList } from '@/api/coupon'
  import { cannelMultipleActivity } from "@/api/campaign"
  export default {
    name: 'activityDialog',
    data () {
      return {
        visible: false,
        orderId: '',
        orderGiftMap: {
          number: '',
          list: []
        },
        orderMultipleMap: {
          number: '',
          list: []
        },
        orderMultipleOriginalSelect: ''
      }
    },
    methods: {
      open (data) {
        this.orderId = data.orderId
        const orderGift = data.orderGiftVOs || []
        const orderMultiple = data.orderMultipleVOs || []
        const orderMultipleSelectList = data.orderMultipleSelectList || []

        this.orderGiftMap.list = orderGift && orderGift.map(v => {
          let couponsCount = 0
          let couponsPriceCount = 0
          v.coupons.forEach(coupon => {
            couponsCount += coupon.count
            couponsPriceCount += (coupon.couponMoney * coupon.count)
          })

          v['couponsCount'] = couponsCount
          v['couponsPriceCount'] = couponsPriceCount

          return v
        }) || []

        this.orderMultipleMap.list = orderMultiple && orderMultiple.map(v => {
          v['threshold'] = (Math.round((v.rule.reachAmount * v.rule.actCount) / 10000 * 100) / 100 || 0)
          v['presentPriceCount'] = v.rule.gifts.reduce((total, gift) => {
            let count = total + (gift.defaultPrice || 0) * (gift.medCount || 0)
            count = Math.round(count * 100) / 100
            return count
          }, 0) || 0
          v['originalPriceCount'] = v.rule.gifts.reduce((total, gift) => {
            let count = total + (gift.price || 0) * (gift.medCount || 0)
            count = Math.round(count * 100) / 100
            return count
          }, 0) || 0
          v['medCount'] = v.rule.gifts.reduce((total, gift) => {
            return total + (gift.medCount || 0)
          }, 0) || 0
          v['giftsText'] = v.rule.gifts.map(gift => {
            return `【${gift.drugCommonName}】${gift.specifications}×${gift.medCount}${gift.unit}`
          }).join(' + ') || ''
          return v
        }) || []

        if (orderMultipleSelectList.length > 0) {
          this.orderMultipleOriginalSelect = orderMultipleSelectList[0]
          const orderMultipleNumber = orderMultipleSelectList[0]
          const orderMultiple = this.orderMultipleMap.list.find(v => { return v.number === orderMultipleNumber })
          if (orderMultiple) {
            this.orderMultipleMap.number = orderMultiple.number
            this.orderMultipleChange()
          } else {
            if (this.orderMultipleMap.list.length === 1) {
              this.orderMultipleMap.number = this.orderMultipleMap.list[0].number
              this.orderMultipleChange()
            }
          }
        } else {
          if (this.orderMultipleMap.list.length === 1) {
            this.orderMultipleMap.number = this.orderMultipleMap.list[0].number
            this.orderMultipleChange()
          }
        }

        this.orderGiftMap.number = ''

        this.visible = true
      },
      async orderMultipleChange () {
        let activityInfos = null

        const activity = this.orderMultipleMap.list.find(v => { return v.number === this.orderMultipleMap.number })
        
        if (activity) {
          activityInfos = {
            type: activity.type,
            number: activity.number
          }
        }

        const res = await getActivityList({ orderId: this.orderId, type: 15, activityInfos: activityInfos ? [activityInfos] : []  })

        if (res.code === 200) {
          const orderGift = res.data.orderGiftVOs || []

          this.orderGiftMap.list = orderGift && orderGift.map(v => {
            let couponsCount = 0
            let couponsPriceCount = 0
            v.coupons.forEach(coupon => {
              couponsCount += coupon.count
              couponsPriceCount += (coupon.couponMoney * coupon.count)
            })

            v['couponsCount'] = couponsCount
            v['couponsPriceCount'] = couponsPriceCount

            return v
          }) || []

          const orderGiftActiveIndex = orderGift.findIndex(v => { return v.number === this.orderGiftMap.number })

          if (orderGiftActiveIndex === -1) {
            this.orderGiftMap.number = ''
          }
        }
      },
      close () {
        this.orderGiftMap.list = []
        this.orderGiftMap.number = ''
        this.orderMultipleMap.list = []
        this.orderMultipleMap.number = ''
        this.visible = false
      },
      async submit () {
        let submitInfo = {
          orderGift: {
            number: '',
            supportDiscount: 1
          },
          orderMultiple: {
            number: '',
            supportDiscount: 1
          }
        }
        if (this.orderMultipleMap.number !== '') {
          const activity = this.orderMultipleMap.list.find(v => v.number === this.orderMultipleMap.number)
          if (activity) {
            submitInfo.orderMultiple.number = activity.number
          }
        }
        if (this.orderGiftMap.number !== '') {
          const activity = this.orderGiftMap.list.find(v => v.number === this.orderGiftMap.number)
          if (activity) {
            submitInfo.orderGift.number = activity.number
            submitInfo.orderGift.supportDiscount = activity.supportDiscount
          }
        }

        if (this.orderMultipleOriginalSelect !== '' && this.orderMultipleMap.number === '') {
          const res = await cannelMultipleActivity({ orderId: this.orderId, number: this.orderMultipleOriginalSelect })
        }
        
        this.$emit('submit', submitInfo)
        this.visible = false
      }
    }
  }
</script>

<style lang="less" scoped>
  .activityDialog /deep/ .el-dialog {
    background: linear-gradient( 180deg, #CCECFF 0%, #F4FBFF 100%);
    border-radius: 6px;
  }

  .activityDialog /deep/ .el-dialog__header {
    padding: 16px 24px 4px;
    border-bottom: none !important;
  }

  .activityDialog /deep/ .el-dialog__header .el-dialog__title {
    line-height: 24px;
    font-weight: bold;
    font-size: 16px;
    color: #000000;
  }

  .activityDialog /deep/ .el-dialog__body {
    padding: 0px 24px 16px;
  }

  .activityDialog /deep/ .el-dialog__footer {
    padding: 12px 24px;
  }

  .content {
    width: 100%;
  }

  .tips {
    line-height: 20px;
    font-size: 14px;
    color: #667182;
  }

  .list {
    box-sizing: border-box;
    margin: 12px 0 0 0;
    padding: 16px;
    width: 100%;
    height: 320px;
    background-color: #FFFFFF;
    border-radius: 6px;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .list_section {
    width: 100%;
  }

  .list_section + .list_section {
    margin: 24px 0 0 0;
  }

  .list_section_title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .list_section_title::before {
    content: '';
    display: block;
    margin: 0 4px 0 0;
    width: 3px;
    height: 14px;
    background-color: #1890FF;
    border-radius: 3px;
  }

  .list_section_title_name {
    line-height: 20px;
    font-weight: bold;
    font-size: 14px;
    color: #000000;
  }

  .list_section_title_description {
    line-height: 20px;
    font-size: 14px;
    color: #000000;
  }

  .list_radio_group {
    margin: 14px 0 0 0;
    width: 100%;
  }

  .list_radio {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 0 0 0 0;
    width: 100%;
  }

  .list_radio+.list_radio {
    margin: 16px 0 0 0;
  }

  .list_radio /deep/ .el-radio__input {
    flex-shrink: 0;
    line-height: 24px;
  }

  .list_radio /deep/ .el-radio__label {
    flex-grow: 1;
    margin: 0 0 0 8px;
    padding: 0 0 0 0;
  }

  .activity_item {
    width: 100%;
  }

  .activity_title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .activity_title_name {
    line-height: 20px;
    font-weight: bold;
    font-size: 14px;
    color: #000000;
  }

  .activity_title_description {
    line-height: 22px;
    font-size: 14px;
    color: #667182;
  }

  .activity_gifts {
    margin: 8px 0 0 0;
    width: 100%;
    line-height: 20px;
    font-size: 13px;
    color: #667182;
    white-space: pre-wrap;
    word-wrap: break-word;
  }

  .activity_title_price {
    margin: 0 2px;
    line-height: 24px;
    font-weight: bold;
    font-size: 16px;
    color: #FE8F1F;
  }

  .activity_title_tag {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 0 0 6px;
    padding: 0 8px;
    height: 20px;
    font-size: 12px;
    color: #FFFFFF;
    background-color: #F54A45;
    border-radius: 2px;
  }

  .coupon_list {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    width: 100%;
    overflow: hidden;
  }

  .coupon_item {
    box-sizing: border-box;
    margin: 6px 8px 0 0;
    padding: 2px 6px;
    min-width: 82px;
    width: fit-content;
    height: 66px;
    background: linear-gradient( 71deg, #FFE9B6 0%, #FFE19C 100%);
    border-radius: 6px;
  }

  .coupon_item_title {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 0 2px 0;
    width: 100%;
    height: 20px;
    font-size: 12px;
    color: #000000;
    border-bottom: 1px solid #E4BB84;
  }

  .coupon_item_num {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  .coupon_item_num_element {
    display: flex;
    justify-content: center;
    align-items: flex-end;
  }

  .coupon_item_num_element_num {
    line-height: 20px;
    font-weight: bold;
    font-size: 14px;
    color: #68481D;
  }

  .coupon_item_num_element_unit {
    line-height: 18px;
    font-size: 12px;
    color: #68481D;
  }

  .coupon_item_condition {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 2px 0 0 0;
    width: 100%;
    line-height: 18px;
    font-size: 12px;
    color: #68481D;
  }

</style>